import React from 'react'
import { Navigate } from "react-router-dom";
import useAuth from "./hooks/useAuth";
import Loading from './Loading';

function Home() {

  const {auth, loading} = useAuth();
  
  if(loading)
    return <Loading />;

  if(auth?.roles?.includes('Common') || auth?.roles?.includes('Administrator'))
  {
    if(!auth?.selectedLocation){
      return <Navigate to="/location" replace/>
    }
    else if(auth?.roles?.includes('Administrator')){
      return <Navigate to="/approve" replace/>
    }
    else if(auth?.roles?.includes('Common')){
      return <Navigate to="/inventoryRequest" replace/>
    }
  }
  else if(auth?.roles?.includes('Maker'))
  {
    return <Navigate to="/paymentrequest" replace/>
  }
  else if(auth?.roles?.includes('Checker'))
  {
    return <Navigate to="/paymentapprove" replace/>
  }
  else if(auth?.roles?.includes('Authorizer'))
  {
    return <Navigate to="/paymentapprove" replace/>
  }
  else{
    return <Navigate to="/login" replace/>
  }
}

export default Home